<template>
  <div style="height: 600px; width: 100%; display: block">
    <el-row style="margin-top: 20px">
      <el-col :span="2">
        <el-button type="primary" size="medium" @click="openConfigureCustomerDialog">
          配置客户
        </el-button>
      </el-col>
      <el-col :span="2">
        <el-button type="primary" size="medium" @click="openEditMealDialog">
          配置餐别
        </el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" stripe border style="margin-top: 20px"
          v-if="this.tableData.length && this.matchedMealList" height>
          <el-table-column prop="mealName" :fit="true" label="" width="80" fixed>
          </el-table-column>
          <el-table-column v-for="(item, index) in tableData[0].detail" :key="item.MEAL_DAY" min-width="200">
            <template slot="header">
              <span>{{ item.weekDay }}<br />{{ item.MEAL_DAY }}</span>
            </template>
            <template slot-scope="scope">
              <el-button type="text" size="small"
                @click="openEditPackageDialog(scope.row.mealId, scope.row.detail[index].MEAL_DAY, scope.row.mealName)"
                v-if="scope.row.detail[index].MEAL_DETAIL.length == 0">
                点击编辑菜单
              </el-button>
              <div v-else>
                <div v-for="(item, index1) in scope.row.detail[index].MEAL_DETAIL" :key="index1">
                  <el-tag effect="plain"
                    @click="openEditPackageDialog(scope.row.mealId, scope.row.detail[index].MEAL_DAY, scope.row.mealName)">
                    {{ item.NAME }}
                  </el-tag>
                  <br />
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!-- 配置客户模态框 -->
    <el-drawer :visible="ConfigureCustomerDialog" :modal="false" @close="ConfigureCustomerDialog = false" size="40%"
      class="spec-drawer">
      <el-row>
        <p style="display: inline-block; margin: -30px 0 10px 2.5%;">已匹配客户</p>
      </el-row>
      <el-row style="margon-top: 10px">
        <el-table :data="matchedCustomers" style="width: 95%; margin-left: 2.5%;" border>
          <el-table-column type="index" label="序号" width="50px">
          </el-table-column>
          <el-table-column prop="TC_NAME" label="客户"> </el-table-column>
          <el-table-column label="操作" min-width="35px">
            <template slot-scope="scope">
              <el-button type="text" @click="delMatchSchool(scope.row)">
                解除匹配
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <el-row>
        <p style="display: inline-block; margin-left: 2.5%;">未匹配客户</p>
      </el-row>
      <el-row>
        <el-input v-model="unmatchedCustomer" style="width: 50%; margin-bottom: 10px; margin-left: 2.5%;"></el-input>
        <el-button size="small" type="primary" @click="filter"> 筛选 </el-button>
        <el-button type="primary" size="small" @click="addMatchSchool">
          匹配
        </el-button>
      </el-row>
      <el-row>
        <el-table :data="unmatchedCustomers" style="width: 95%; margin: 10px 0 10px 2.5%;" border
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column prop="TC_NAME" label="客户"> </el-table-column>
        </el-table>
      </el-row>
    </el-drawer>
    <!-- 配置套餐模态框 -->
    <el-drawer :visible="editPackageDialog" :modal="false" @close="editPackageDialog = false" size="40%"
      class="spec-drawer">
      <el-row>
        <el-col :span="16" style="margin: 20px 0 0 2.5%">
          {{ this.getWeekDay(editPackageDialogData.mealDay) }}<br />
          {{ editPackageDialogData.mealDay }}
        </el-col>
        <el-col :span="7" style="font-size: 24px; margin-top: 24px">
          <b>{{ editPackageDialogData.mealName }}</b>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="16">
          <el-select v-model="editPackageDialogData.selectedPackage" placeholder=""
            style="width: 90%; margin: 0 0 30px 2.5%">
            <el-option v-for="item in packageList" :key="item.MEAL_PRODUCT_CODE" :label="item.NAME"
              :value="item.MEAL_PRODUCT_CODE">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="1">
          <el-button @click="MatchPackage"> 添加 </el-button>
        </el-col>
      </el-row>
      <el-row>
        <p style="display: inline-block; margin-left: 2.5%;">已添加菜品</p>
      </el-row>
      <el-row>
        <el-table :data="matchedPackages" style="width: 95%; margin-left: 2.5%;" border>
          <el-table-column type="index" label="序号" width="50px">
          </el-table-column>
          <el-table-column prop="NAME" label="商品"> </el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位" min-width="30px">
          </el-table-column>
          <el-table-column label="操作" min-width="28px">
            <template slot-scope="scope">
              <el-button type="text" @click="deleteMatchedPackage(scope.row)">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
    </el-drawer>
    <!-- 配置餐别模态框 -->
    <el-drawer :visible="editMealDialog" :modal="false" @close="editMealDialog = false" size="40%" class="spec-drawer">
      <el-row>
        <el-col :span="16">
          <el-select v-model="selectedMeal" placeholder="" style="width: 90%; margin-bottom: 30px">
            <el-option v-for="item in mealList" :key="item.ID" :label="item.MEAL_NAME" :value="item.ID">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="1">
          <el-button @click="matchMeal"> 添加 </el-button>
        </el-col>
      </el-row>
      <el-row>
        <p>已添加餐别</p>
      </el-row>
      <el-row style="margon-top: 10px">
        <el-table :data="matchedMealList" style="width: 99%" border>
          <el-table-column prop="MEAL_NAME" label="餐别"> </el-table-column>
          <el-table-column label="操作" min-width="28px">
            <template slot-scope="scope">
              <el-button type="text" @click="deleteMatchedMeal(scope.row)">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
    </el-drawer>
  </div>
</template>
<script>
import {
  getAllSchoolFun, addMatchSchoolFun, getMatchSchoolFun,
  delMatchSchoolFun, getAllPackageFun, getPackageGroupDetailFun,
  getAllMealFun, matchMealFun, deleteMatchedMealFun,
  getMatchedMealFun, getRecipeDetailFun, MatchPackageFun,
  deleteMatchedPackageFun,
} from 'api/packageManage';

export default {
  data() {
    return {
      recipeList: [],
      tableData: [],
      selectedMeal: '',
      mealList: [],
      mealDayList: [],
      matchedMealList: [],
      matchedCustomers: [],
      unmatchedCustomer: '',
      unmatchedCustomers: [],
      allCustomers: [],
      matchedPackages: [],
      multipleSelection: [],
      ConfigureCustomerDialog: false,
      editPackageDialog: false,
      editPackageDialogData: {
        selectedPackage: '',
        mealDay: '',
        mealTypeId: '',
        mealName: '',
      },
      editMealDialog: false,
      packageList: [],
    };
  },
  methods: {
    openConfigureCustomerDialog() {
      this.ConfigureCustomerDialog = !this.ConfigureCustomerDialog;
      this.unmatchedCustomers = this.allCustomers;
    },
    openEditMealDialog() {
      this.editMealDialog = !this.editMealDialog;
    },
    openEditPackageDialog(mealTypeId, mealDay, mealName) {
      this.editPackageDialog = true;
      this.editPackageDialogData.mealDay = mealDay;
      this.editPackageDialogData.mealTypeId = mealTypeId;
      this.editPackageDialogData.mealName = mealName;
      this.getRecipeDetail(mealTypeId, mealDay);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getAllSchool() {
      const params = {
        PACKAGE_ID: sessionStorage.getItem('mealGroupId'),
      };
      getAllSchoolFun(params).then((result) => {
        if (result.length !== 0) {
          this.allCustomers = result;
          console.log('unmatchedCustomers', this.unmatchedCustomers);
        } else {
          this.unmatchedCustomers = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    addMatchSchool() {
      const tmpArr = [];
      this.multipleSelection.map((item) => {
        tmpArr.push(item.TC_ID);
      });
      const params = {
        PACKAGE_ID: sessionStorage.getItem('mealGroupId'),
        TC_ARRAY: tmpArr,
      };
      addMatchSchoolFun(params).then((result) => {
        this.$message.show({ text: '新增成功', type: 'success' });
        this.getMatchSchool();
        this.getAllSchool();
        this.unmatchedCustomers = this.allCustomers;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    getMatchSchool() {
      const params = {
        PACKAGE_ID: sessionStorage.getItem('mealGroupId'),
      };
      getMatchSchoolFun(params).then((result) => {
        if (result.length !== 0) {
          this.matchedCustomers = result;
        } else {
          this.matchedCustomers = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    delMatchSchool(row) {
      this.$confirm('确认解除该匹配吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          RELEATION_ID: row.ID,
        };
        delMatchSchoolFun(params).then((res) => {
          this.getMatchSchool();
          this.getAllSchool();
          this.unmatchedCustomers = this.allCustomers;
          this.$message.show({ text: '操作成功', type: 'success' });
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作',
        });
      });
    },
    queryAllPackage() {
      const params = {};
      getAllPackageFun(params).then((result) => {
        if (result.length !== 0) {
          this.packageList = result;
        } else {
          this.packageList = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    getPackageGroupDetail() {
      const params = {
        ID: sessionStorage.getItem('mealGroupId'),
      };
      getPackageGroupDetailFun(params).then((result) => {
        if (result.length !== 0) {
          this.recipeList = result;
          for (let i = 0; i < this.recipeList.length; i++) {
            this.mealDayList[i] = this.recipeList[i].MEAL_DAY;
          }
          this.setTableData();
        } else {
          this.recipeList = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    getAllMeal() {
      getAllMealFun().then((result) => {
        this.mealList = result;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    matchMeal() {
      const params = {
        PACKAGE_ID: sessionStorage.getItem('mealGroupId'),
        MEAL_TYPE_ID: this.selectedMeal,
      };
      matchMealFun(params).then((result) => {
        this.$message.show({ text: '新增成功', type: 'success' });
        this.getMatchedMeal();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    deleteMatchedMeal(row) {
      const params = {
        PACKAGE_ID: sessionStorage.getItem('mealGroupId'),
        MEAL_TYPE_ID: row.MEAL_TYPE_ID,
      };
      deleteMatchedMealFun(params).then((result) => {
        this.$message.show({ text: '删除成功', type: 'success' });
        this.getMatchedMeal();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    getMatchedMeal() {
      const params = {
        PACKAGE_ID: sessionStorage.getItem('mealGroupId'),
      };
      getMatchedMealFun(params).then((result) => {
        this.matchedMealList = result;
        this.getPackageGroupDetail();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    setTableData() {
      this.tableData = [];
      for (let i = 0; i < this.matchedMealList.length; i++) {
        const row = {
          mealName: this.matchedMealList[i].MEAL_NAME,
          mealId: this.matchedMealList[i].ID,
          detail: [],
        };
        for (let j = 0; j < this.recipeList.length; j++) {
          const cell = {
            MEAL_DAY: this.recipeList[j].MEAL_DAY,
            weekDay: this.getWeekDay(this.recipeList[j].MEAL_DAY),
            MEAL_DETAIL: [],
          };
          row.detail.push(cell);
        }
        this.tableData.push(row);
      }
      for (let i = 0; i < this.tableData.length; i++) {
        for (let j = 0; j < this.tableData[i].detail.length; j++) {
          this.getRecipeDetail(this.tableData[i].mealId, this.tableData[i].detail[j].MEAL_DAY);
        }
      }
      console.log('tableData', this.tableData);
    },
    getWeekDay(data) {
      let day;
      switch (new Date(data).getDay()) {
        case 0:
          day = '周日';
          break;
        case 1:
          day = '周一';
          break;
        case 2:
          day = '周二';
          break;
        case 3:
          day = '周三';
          break;
        case 4:
          day = '周四';
          break;
        case 5:
          day = '周五';
          break;
        default:
          day = '周六';
          break;
      }
      return day;
    },
    async getRecipeDetail(mealTypeId, mealDay) {
      const params = {
        PACKAGE_ID: sessionStorage.getItem('mealGroupId'),
        MEAL_TYPE_ID: mealTypeId,
        MEAL_DAY: mealDay,
      };
      await getRecipeDetailFun(params).then((result) => {
        this.matchedPackages = result;
        this.tableData.find((item) => item.mealId == mealTypeId)
          .detail.find((item) => item.MEAL_DAY == mealDay)
          .MEAL_DETAIL = this.matchedPackages;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    MatchPackage() {
      const params = {
        PACKAGE_ID: sessionStorage.getItem('mealGroupId'),
        MEAL_TYPE_ID: this.editPackageDialogData.mealTypeId,
        MEAL_DAY: this.editPackageDialogData.mealDay,
        MEAL_PRODUCT_CODE: this.editPackageDialogData.selectedPackage,
      };
      MatchPackageFun(params).then((result) => {
        this.$message.show({ text: '添加成功', type: 'success' });
        this.getRecipeDetail(this.editPackageDialogData.mealTypeId, this.editPackageDialogData.mealDay);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    deleteMatchedPackage(row) {
      const params = {
        PACKAGE_MEAL_RELATION_ID: row.PACKAGE_MEAL_RELATION_ID,
      };
      deleteMatchedPackageFun(params).then((result) => {
        this.$message.show({ text: '删除成功', type: 'success' });
        this.getRecipeDetail(this.editPackageDialogData.mealTypeId, this.editPackageDialogData.mealDay);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    filter() {
      this.unmatchedCustomers = this.allCustomers;
      if (this.unmatchedCustomer) {
        this.unmatchedCustomers = this.unmatchedCustomers.filter((item) => item.TC_NAME.includes(this.unmatchedCustomer));
      }
    },
  },
  created() {
    this.getMatchSchool();
    this.queryAllPackage();
    this.getAllMeal();
    this.getMatchedMeal();
    this.getAllSchool();
  },
};
</script>
<style scoped>
.spec-drawer /deep/ .el-drawer__body {
  padding: 3px 30px;
  overflow-y: auto;
  height: calc(100vh - 140px);
}
</style>



// WEBPACK FOOTER //
// src/components/productionProcessing/editRecipe.vue